const React = require('react');
import Select from 'react-select';

export class UserSelector extends React.Component{
   constructor(props) {
      super(props);
   }

   onFieldChange(selectedOptions){
      this.props.onSelectChange(selectedOptions);
   }

   render() {

      return (
         <div className='conjecture-creation-user-selector'>
            Pick up to 3 people connected to you to send your Conjecture to.
            <Select
               options={this.props.options}
               value={this.props.curSelection}
               isMulti
               onChange={(selectedOptions) => this.onFieldChange(selectedOptions) }
               id={'topic-search-text-input'}
               closeMenuOnSelect={false}
            />

         </div>
      );
   }
}